var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      "padding-top": "100px",
      width: "100%"
    }
  }, [_c("img", {
    staticStyle: {
      width: "70%",
      display: "block",
      margin: "0 auto"
    },
    attrs: {
      src: _vm.url,
      alt: "404"
    }
  }), _vm.visibleModal ? _c("passwordSafeModal", {
    ref: "passwordSafeModal",
    attrs: {
      visibleModal: _vm.visibleModal
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };